module.exports = __webpack_public_path__ + "assets/normal/images/people.07fd7321.png";